module.exports = __webpack_public_path__ + "img/lookbook_1_border.14e88282.png";